module.exports = __webpack_public_path__ + "static/media/shaw.c0ae8b4d.png";